module.exports = __webpack_public_path__ + "static/img/bg-es.02f5b088.webp";